import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/home';
import Help from '@/views/help';
import Tools from '@/views/tools';
import Compliance from '@/views/compliance';

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/tools',
      name: 'Tools',
      component: Tools
    },
    {
      path: '/help',
      name: 'Help',
      component: Help
    },
    {
      path: '/compliance',
      name: 'Compliance',
      component: Compliance
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js